import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 19h18v2H3zM3 7h12v2H3zm0-4h18v2H3zm0 12h12v2H3zm0-4h18v2H3z"
}), 'FormatAlignLeftTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FormatAlignLeftTwoTone.js
// module id = 3808
// module chunks = 2